import React from "react";
import Carousel from "react-bootstrap/Carousel";

const Banner = () => {
  return (
    <div>
      <Carousel fade indicators={false}>
        <Carousel.Item>
          <img src="./images/cover.JPG" className="w-100" alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img src="./images/cover.JPG" className="w-100" alt="" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Banner;
